export default __webpack_public_path__ + "static/media/AmazonPay.4600c1e6.svg";